/*global process */
import React from 'react';
import Modal from 'react-modal';
import Slider from 'react-slick';
import './itemDetailModal.css';
import WalmartButton from '../../walmart/walmartButton.js';
import Select from 'react-select';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import FilterConstants from '../../../constants/filter.js';
import LowSrc from './lowsrc.js';
import loadingImage from '../../../images/product-loading.gif';
class ItemDetailModal extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedSizeIndex: 0
    };
  }

  render() {
    const imagePaths = this.props.images;
    const highlightText = this.props.highlights;
    const gameText = this.props.game;
    const sizes = this.props.sizes;
    const slickSettings = {
      infinite: true,
      focusOnSelect: true,
      dots: true,
      touchMove: true,
      arrows: (imagePaths.length > 1),
      className: 'slick-inner',
      dotsClass: (imagePaths.length > 1) ? 'rt-dots' : 'rt-hidden-dots',
    };
    
    const images = imagePaths.map((image, index) => {
      return (
        <LowSrc key={index} src={process.env.PUBLIC_URL + image} lowsrc={loadingImage} className='slide' alt='Product'></LowSrc>
      );
    });

    const highlights = highlightText.map((highlight, index) => {
      return (
        <li key={index}>{highlight}</li>
      );
    });

    const game = gameText.map((g) => {
      return FilterConstants.gameIcons[g];
    }); 

    const sizeOptions = sizes.map((size, index) => {
      return {
        value: index,
        label: size.size
      };
    });

    const name = this.props.name;
    const price = this.props.sizes[this.state.selectedSizeIndex].price;
    const id = this.props.sizes[this.state.selectedSizeIndex].walmartID;
    const onSizeSelection = (sizeOption) => {
      this.setState({selectedSizeIndex: sizeOption.value});
    };

    const sizeSelector = (
      <Select
        name="size-selection"
        options={sizeOptions}
        searchable={false}
        value={sizeOptions[this.state.selectedSizeIndex]}
        onChange={onSizeSelection}
        clearable={false}
        placeholder="Size"
        className="size-modal-select"
      />
    );

    const walmartButton = (
      <WalmartButton 
        name={name}
        price={price}
        id={id}
        addToCart={true}
      />
    );

    return (
      <Modal 
        isOpen={this.props.isOpen}
        contentLabel="Item Details">
        <MediaQuery query="(max-width: 568px)">
          {/* PHONE VERTICAL */}
          <div className='details'>
            <button className='close-button' onClick={this.props.closeModal}>×</button>
            <div className='modal-info'>
              <h1 className='title'>{name}</h1>
              <span className='price'>{price}</span>
            </div>
            <div className='modal-slider'>
              <Slider {...slickSettings}>
                {images}
              </Slider>
            </div>
            <div className='modal-info'>
              <div className='purchase'>
                {sizeSelector}
                {walmartButton}
              </div>
              <div className='subhead'>Product Features</div>
              <div className='product-features'>
                <ul>{highlights}</ul>
                <div className='divider'></div>
                <ul className='feature-icons'>{game}{FilterConstants.patternIcons[this.props.pattern]}</ul>
              </div>
            </div>
          </div>
        </MediaQuery>

        <MediaQuery query="(min-width: 568px)">
          {/* if above 568: */}
          <MediaQuery query="(max-width: 760px)">
            {/* PHONE HORIZ */}
            <div className='details'>
              <button className='close-button' onClick={this.props.closeModal}>×</button>
              <div className='modal-slider'>
                <Slider {...slickSettings}>
                  {images}
                </Slider>
              </div>
              <div className='modal-divider'>
                <div className='divider'></div>
              </div>
              <div className='modal-info'>
                <h1 className='title'>{name}</h1>
                <span className='price'>{price}</span>
                <div className='purchase'>
                  {sizeSelector}
                  {walmartButton}
                </div>
                <div className='subhead'>Product Features</div>
                <div className='product-features'>
                  <ul>{highlights}</ul>
                  <div className='divider'></div>
                  <ul className='feature-icons'>{game}{FilterConstants.patternIcons[this.props.pattern]}</ul>
                </div>
              </div>
            </div>
          </MediaQuery>

          <MediaQuery query="(min-width: 761px)">
            {/* if above 760: */}

            <MediaQuery query="(max-width: 900px)">
              {/* TABLET VERTICAL */}
              <div className='details'>
                <button className='close-button' onClick={this.props.closeModal}>×</button>
                <div className='modal-info'>
                  <h1 className='title'>{name}</h1>
                  <span className='price'>{price}</span>
                </div>
                <div className='modal-slider'>
                  <Slider {...slickSettings}>
                    {images}
                  </Slider>
                </div>
                <div className='modal-info'>
                  <div className='purchase'>
                    {sizeSelector}
                    {walmartButton}
                  </div>
                  <div className='subhead'>Product Features</div>
                  <div className='product-features'>
                    <ul>{highlights}</ul>
                    <div className='divider'></div>
                    <ul className='feature-icons'>{game}{FilterConstants.patternIcons[this.props.pattern]}</ul>
                  </div>
                </div>
              </div>
            </MediaQuery>

            <MediaQuery query="(min-width: 900px)">
              {/* TABLET+ HORIZ */}
              <div className='details'>
                <button className='close-button' onClick={this.props.closeModal}>×</button>
                <div className='modal-slider'>
                  <Slider {...slickSettings}>
                    {images}
                  </Slider>
                </div>
                <div className='modal-divider'>
                  <div className='divider'></div>
                </div>
                <div className='modal-info'>
                  <h1 className='title'>{name}</h1>
                  <span className='price'>{price}</span>
                  <div className='purchase'>
                    {sizeSelector}
                    {walmartButton}
                  </div>
                  <div className='subhead'>Product Features</div>
                  <div className='product-features'>
                    <ul>{highlights}</ul>
                    <div className='divider'></div>
                    <ul className='feature-icons'>{game}{FilterConstants.patternIcons[this.props.pattern]}</ul>
                  </div>
                </div>
              </div>
            </MediaQuery>

          </MediaQuery>


        </MediaQuery>

        
      </Modal>
    );
  }
}

ItemDetailModal.propTypes = {
  images: PropTypes.array.isRequired,
  highlights: PropTypes.array.isRequired,
  game: PropTypes.array,
  sizes: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  pattern: PropTypes.string.isRequired
};

export default ItemDetailModal;


// WEBPACK FOOTER //
// ./src/components/item/itemDetailModal/itemDetailModal.js